<template>
  <el-drawer
    :model-value="visible"
    title="预览"
    direction="rtl"
    size="420px"
    destroy-on-close
    class="product-mp-preview-drawer"
    @close="emit('update:visible', false)"
  >
    <div class="mp-preview-shell">
      <div class="mp-preview-phone">
        <div v-if="loading" class="mp-preview-state">
          <el-icon class="is-loading"><Loading /></el-icon>
          <span>加载中...</span>
        </div>
        <div v-else-if="error" class="mp-preview-state mp-preview-state--error">
          <span>{{ error }}</span>
          <el-button size="small" @click="loadDetail">重试</el-button>
        </div>
        <template v-else-if="details">
          <div ref="scrollRef" class="mp-preview-scroll">
            <div class="mp-detail-preview">
              <div class="details-top-image-wrapper">
                <el-carousel
                  v-if="swiperImages.length"
                  height="auto"
                  :autoplay="false"
                  indicator-position="none"
                  arrow="never"
                  @change="(idx) => (swiperCurrent = idx)"
                >
                  <el-carousel-item v-for="(item, index) in swiperImages" :key="index">
                    <img class="details-top-image" :src="swiperImageSrc(item)" alt="" />
                  </el-carousel-item>
                </el-carousel>
                <div v-if="swiperImages.length > 1" class="swiper-indicators-wrapper">
                  <div class="swiper-indicators">
                    <span
                      v-for="(_, index) in swiperImages"
                      :key="index"
                      class="swiper-indicator"
                      :class="{ 'swiper-indicator-active': swiperCurrent === index }"
                    />
                  </div>
                </div>
              </div>

              <div v-if="details.info?.sale_status" class="sale-status-badge">
                {{ details.info.sale_status }}
              </div>

              <div class="gutter">
                <div class="details-mid">
                  <div class="details-mid-top">
                    <div class="details-mid-tit">
                      {{ details.info?.title }}
                      <span v-if="details.is_show_stock == 1" class="stock-badge">
                        剩余{{ details.total_stock }}件
                      </span>
                    </div>
                  </div>
                  <div class="details-mid-sub">
                    <span>{{ details.info?.subtitle }}</span>
                    <span>¥{{ totalPrice }}</span>
                  </div>
                  <div class="divider" />

                  <div v-if="showCraftTags" class="craft-tags-section">
                    <div class="craft-tags-wrapper">
                      <span v-if="details.info?.is_custom == 1" class="attribute-tag">定   制</span>
                      <span v-if="details.info?.is_alone == 1" class="attribute-tag">孤   品</span>
                      <span v-if="details.info?.is_alone == 2" class="attribute-tag">瑕   疵</span>
                      <span v-if="details.info?.is_alone == 3" class="attribute-tag">盲   盒</span>
                      <span
                        v-for="(tag, tagIndex) in craftTags"
                        :key="'craft-' + tagIndex"
                        class="attribute-tag"
                      >{{ tag }}</span>
                    </div>
                  </div>

                  <div class="details-mid-desc">
                    {{ colorDescription }}
                  </div>

                  <div v-if="details.info?.colors?.length" class="spec-section">
                    <div class="spec-title">{{ details.info?.color_spec_name || '颜色规格' }}</div>
                    <div class="spec-options">
                      <div
                        v-for="(item, index) in details.info.colors"
                        :key="item.id || index"
                        class="spec-option-item"
                        :class="{ on: colorId == item.id, disabled: !isColorAvailable(item.id) }"
                        :style="item.color ? { backgroundColor: item.color, borderColor: item.color } : undefined"
                        @click="onColorTap(item.id, index)"
                      >
                        {{ item.color_name }}
                      </div>
                    </div>
                  </div>

                  <div v-if="details.info?.spec1?.length" class="spec-section">
                    <div class="spec-title">{{ details.info?.spec1_name || '规格表1' }}</div>
                    <div class="spec-options">
                      <div
                        v-for="(item, index) in details.info.spec1"
                        :key="item.id || index"
                        class="spec-option-item"
                        :class="{ on: spec1Id == item.id, disabled: !isSpec1Available(item.id) }"
                        @click="onSpec1Tap(item.id, index)"
                      >
                        {{ item.color_name }}
                      </div>
                    </div>
                  </div>

                  <div v-if="details.info?.spec2?.length" class="spec-section">
                    <div class="spec-title">{{ details.info?.spec2_name || '规格表2' }}</div>
                    <div class="spec-options">
                      <div
                        v-for="(item, index) in details.info.spec2"
                        :key="item.id || index"
                        class="spec-option-item"
                        :class="{ on: spec2Id == item.id, disabled: !isSpec2Available(item.id) }"
                        @click="onSpec2Tap(item.id, index)"
                      >
                        {{ item.color_name }}
                      </div>
                    </div>
                  </div>

                  <div class="divider-unsee" />
                  <div class="notice pb10">
                    <div v-if="details.info?.notice1?.trim()" class="notice-section">
                      <div class="notice-content">
                        <span class="asterisk">*</span>{{ details.info.notice1 }}
                      </div>
                    </div>
                    <div v-if="details.info?.notice2?.trim()" class="notice-section">
                      <div class="notice-content">
                        <span class="asterisk">*</span>{{ details.info.notice2 }}
                      </div>
                    </div>
                  </div>

                  <div class="divider" />

                  <div v-if="colorDetailImages.length" class="details-grid">
                    <div
                      v-for="(item, index) in colorDetailImages"
                      :key="'grid-' + index"
                      class="details-grid-item"
                    >
                      <img class="load-img" :src="item" alt="" />
                    </div>
                  </div>

                  <div v-if="mainDetailImages.length" class="details-main-images">
                    <div v-for="(item, index) in mainDetailImages" :key="'main-' + index">
                      <img class="details-main-image" :src="item" alt="" />
                    </div>
                  </div>
                </div>
              </div>
            </div>
          </div>

          <div class="fixed-footer">
            <div class="fixed-footer-inner mp-detail-preview">
              <div class="bottom-service-btn">客服</div>
              <div class="bottom-collect-btn">☆</div>
              <div v-if="!isBeforeSaleTime" class="cart-btn">购</div>
              <div
                v-if="details.info?.is_custom == 1 && !isBeforeSaleTime"
                class="custom-btn"
              >
                去定制
              </div>
              <div class="buy-btn" :class="{ 'buy-btn-disabled': isBeforeSaleTime }">
                {{ isBeforeSaleTime ? '未开售' : '购买/buying' }}
              </div>
            </div>
          </div>
        </template>
      </div>
      <p class="mp-preview-tip">预览效果与小程序商品详情页一致，仅供查看</p>
    </div>
  </el-drawer>
</template>

<script setup>
import { computed, ref, watch } from 'vue'
import axios from 'axios'
import { Loading } from '@element-plus/icons-vue'
import {
  craftTagsArray,
  computeTotalPrice,
  getColorDetailImages,
  getMainDetailImages,
  getSelectedColor,
  getSpecStock,
  getSwiperImages,
  initProductDetailSelection,
  showCraftTagsSection,
} from '@/shared/product-detail/productDetailLogic'

const props = defineProps({
  visible: { type: Boolean, default: false },
  productId: { type: [Number, String], default: null },
})

const emit = defineEmits(['update:visible'])

const loading = ref(false)
const error = ref('')
const details = ref(null)
const scrollRef = ref(null)

const colorId = ref('')
const colorIndex = ref(-1)
const spec1Id = ref('')
const spec1Index = ref(-1)
const spec2Id = ref('')
const spec2Index = ref(-1)
const swiperCurrent = ref(0)
const swiperHeights = ref([])

const selectedColor = computed(() => getSelectedColor(details.value, colorId.value, colorIndex.value))
const swiperImages = computed(() => getSwiperImages(details.value, selectedColor.value))
const colorDetailImages = computed(() => getColorDetailImages(selectedColor.value))
const mainDetailImages = computed(() => getMainDetailImages(details.value?.info))
const craftTags = computed(() => craftTagsArray(details.value?.info?.craft_tags))
const showCraftTags = computed(() => showCraftTagsSection(details.value?.info))
const totalPrice = computed(() =>
  computeTotalPrice(details.value, {
    colorId: colorId.value,
    colorIndex: colorIndex.value,
    spec1Id: spec1Id.value,
    spec1Index: spec1Index.value,
    spec2Id: spec2Id.value,
    spec2Index: spec2Index.value,
  })
)
const colorDescription = computed(() => {
  if (selectedColor.value?.description !== undefined) return selectedColor.value.description
  return details.value?.info?.description || ''
})
const isBeforeSaleTime = computed(() => {
  const start = details.value?.info?.start_time
  if (!start) return false
  const ts = new Date(String(start).replace(/-/g, '/')).getTime()
  return !Number.isNaN(ts) && ts > Date.now()
})

const stockItems = computed(() => details.value?.stock_items || {})

const swiperImageSrc = (item) => {
  if (!item) return ''
  const suffix = colorId.value ? `?t=${colorId.value}` : ''
  return `${item}${suffix}`
}

const resetSelection = () => {
  const state = initProductDetailSelection(details.value)
  colorId.value = state.colorId
  colorIndex.value = state.colorIndex
  spec1Id.value = state.spec1Id
  spec1Index.value = state.spec1Index
  spec2Id.value = state.spec2Id
  spec2Index.value = state.spec2Index
  swiperCurrent.value = 0
  swiperHeights.value = []
}

const loadDetail = async () => {
  if (!props.productId) return
  loading.value = true
  error.value = ''
  try {
    const res = await axios.get('/api/Product/productInfo', { params: { id: props.productId } })
    const body = res?.data
    if (body?.code !== 1 || !body?.data?.info) {
      throw new Error(body?.msg || '获取商品详情失败')
    }
    details.value = body.data
    resetSelection()
  } catch (err) {
    details.value = null
    error.value = err?.message || '加载失败'
  } finally {
    loading.value = false
  }
}

const isColorAvailable = (id) => {
  const spec1 = details.value?.info?.spec1 || []
  const spec2 = details.value?.info?.spec2 || []
  if (!spec1.length && !spec2.length) {
    return getSpecStock(stockItems.value, id, 0, 0) > 0
  }
  if (spec1.length && !spec2.length) {
    return spec1.some((item) => getSpecStock(stockItems.value, id, item.id, 0) > 0)
  }
  if (!spec1.length && spec2.length) {
    return spec2.some((item) => getSpecStock(stockItems.value, id, 0, item.id) > 0)
  }
  return spec1.some((s1) => spec2.some((s2) => getSpecStock(stockItems.value, id, s1.id, s2.id) > 0))
}

const isSpec1Available = (id) => {
  const spec2 = details.value?.info?.spec2 || []
  const cid = colorId.value || 0
  if (!spec2.length) return getSpecStock(stockItems.value, cid, id, 0) > 0
  return spec2.some((item) => getSpecStock(stockItems.value, cid, id, item.id) > 0)
}

const isSpec2Available = (id) =>
  getSpecStock(stockItems.value, colorId.value || 0, spec1Id.value || 0, id) > 0

const onColorTap = (id, index) => {
  if (!isColorAvailable(id)) return
  colorId.value = id
  colorIndex.value = index
  swiperCurrent.value = 0
}

const onSpec1Tap = (id, index) => {
  if (!isSpec1Available(id)) return
  spec1Id.value = id
  spec1Index.value = index
}

const onSpec2Tap = (id, index) => {
  if (!isSpec2Available(id)) return
  spec2Id.value = id
  spec2Index.value = index
}

watch(
  () => [props.visible, props.productId],
  ([visible, id]) => {
    if (visible && id) loadDetail()
  },
  { immediate: true }
)

watch(swiperImages, () => {
  swiperCurrent.value = 0
})
</script>

<style scoped lang="scss">
@use '@/shared/product-detail/product-detail-preview.scss';

.product-mp-preview-drawer :deep(.el-drawer__body) {
  padding: 0 16px 16px;
  overflow: hidden;
}

.mp-preview-shell {
  height: 100%;
  display: flex;
  flex-direction: column;
  align-items: center;
}

.mp-preview-phone {
  position: relative;
  width: 375px;
  height: calc(100vh - 140px);
  max-height: 780px;
  border: 10px solid #1a1a1a;
  border-radius: 28px;
  overflow: hidden;
  background: #fff;
  box-shadow: 0 12px 40px rgba(0, 0, 0, 0.15);
}

.mp-preview-scroll {
  height: 100%;
  overflow-x: hidden;
  overflow-y: auto;
  -webkit-overflow-scrolling: touch;
}

:deep(.el-carousel__container) {
  min-height: 280px;
}

.mp-preview-state {
  height: 100%;
  display: flex;
  flex-direction: column;
  align-items: center;
  justify-content: center;
  gap: 12px;
  color: #666;
  font-size: 14px;
}

.mp-preview-state--error {
  padding: 24px;
  text-align: center;
}

.mp-preview-tip {
  margin: 12px 0 0;
  font-size: 12px;
  color: #999;
  text-align: center;
}
</style>
